import { getBaseUrl, request } from 'src/helper/api';

// Get vendors list
export const getVendors = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendors',
  );
export const getVendorDetails = (token?: string, vendorId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendors/${vendorId}`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/getVendorDetails',
  );
export const updateVendorStatus = (token?: string, vendorId?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'PATCH',
      url: `${getBaseUrl()}api/vendors/${vendorId}/actions/updateStatus`,
      contentType: 'json',
      token,
      signal,
    },
    'vendors/updateVendorStatus',
  );

export const resendOnboardingLink = (token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/generate-signed-url`,
      contentType: 'json',
      token,
    },
    'vendors/resendOnboardingLink',
  );

export const approvedUnderReview = (token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-status`,
      contentType: 'json',
      token,
    },
    'vendors/setStatus',
  );
